import React, { Suspense, useEffect } from 'react';
import { Layout, Spin } from 'antd';
import ROUTER_CONFIG from 'configs/routes';
// import { Route, Routes, useNavigate } from 'react-router-dom';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Headers from 'components/Headers';
import SideMenu from 'components/SideMenu';
import 'assets/css/index.less';
import styles from './index.module.less';
import { useConcent } from 'concent';
import AuthRoute from './authRoute';
import menus from 'configs/menus';
import { getPathQueue } from './helper';
import WxLogin from './wxLogin';
import PswLogin from './pswLogin';
import { getIsRtxLogin, getIsWxLogin, getIsExistLoginType, getLoginAccountType, getUserKey } from 'utils/common';
import { getUrlParams } from 'utils/url';
import { IS_VERIFY_TYPE, LOGIN_TYPE } from 'configs/constant/common';
const { Content, Sider } = Layout;

function Layouts() {
  const navigate = useNavigate();
  const userCtx = useConcent({ module: 'user' });
  const { userId, accountType, userRole, authList } = userCtx.state;
  const location = useLocation();
  const { pathname } = location;
  const { loginType = '' as any } = getUrlParams(window.location.href);
  if (loginType === LOGIN_TYPE.rtx) {
    localStorage.setItem('UG_CAIDATA_LOGIN_TYPE', LOGIN_TYPE.rtx);
  }
  // const { themeColor, fistInHead, headMenuTheme, sideMenuTheme } = state.layout;
  // const { panguTree } = state.user.baseInfo;
  // // 菜单相关计算属性
  const paths = getPathQueue(menus, pathname); // 面包屑导航路径
  const openKeys = paths.map((m) => m.name); // 打开的菜单
  const handMenuName = paths?.[0]?.name; // 头部选中菜单
  const sideMenu: any = menus.find((i) => i.name === handMenuName) || {}; // 头部菜单
  // const tailMenu = (paths && paths[paths.length - 1]) || {}; // 尾部菜单
  // const siderMenus = fistInHead && !handMenu.isHideSider && !tailMenu.isHideSider ? handMenu.children : [];
  // 是否微信登录
  const isWxLogin = getIsWxLogin(localStorage.getItem('UG_CAIDATA_LOGIN_TYPE') || '');
  const isRtxLogin = getIsRtxLogin(accountType);
  // const isPswLogin = getIsPswLogin();

  // 非微信和rtx登录且未登录前往登录界面
  // if (!isWxLogin && !isRtxLogin && !user && pathname !== '/login') {
  //   navigate('/login');
  // }
  // const navigate = useNavigate();
  // oa登录查询rtx用户登录/权限信息
  // const getUser = async () => {
  //   const res = await userCtx?.dispatch('getOaUserInfo');
  //   const { roleList } = res;
  //   if (roleList?.length <= 0) {
  //     // 二期再接入权限控制
  //     // navigate('/exception-403');
  //   }
  // };

  // const getPswUser = async () => {
  //   const data = await userCtx?.dispatch('getPswUserInfo', {
  //     user_id: getUserKey(user),
  //   });

  //   if (!data.login) {
  //     navigate('/login');
  //   }
  // };

  const getCaiUserInfo = async () => {
    const loginLocalType = getLoginAccountType();
    if ([LOGIN_TYPE.rtx].includes(loginLocalType)) {
      await userCtx?.dispatch('/woaLogin');
    }

    // if (isNeedWxLogin) {
    //   await userCtx?.dispatch('/wxLogin', { openId: getUserKey(userId) });
    // }

    const data = await userCtx?.dispatch('getCaiDataUserInfo', {
      user_id: getUserKey(userId),
      account_type: getLoginAccountType(),
    });

    if (!data.user_id) {
      // 如果是cookie过期校验不通过则跳转到登录，校验通过但是db未配置用户信息则去授权页面
      console.log('isWxLogin', isWxLogin, data.isVerify, [LOGIN_TYPE.wx].includes(loginType));
      if (isWxLogin) {
        // message.info('联系开发jiangyinsu配置用户信息后可查看系统功能');
        if (getUserKey(userId) || [LOGIN_TYPE.wx].includes(loginType)) {
          userCtx.setState({ openId: getUserKey(userId) });
          navigate('/exception-403');
        } else {
          navigate('/login');
        }
        return;
      }
      if (data.isVerify === IS_VERIFY_TYPE.isNoAuth) {
        navigate('/exception-403');
      } else {
        navigate('/login');
      }
    }
  };

  useEffect(() => {
    (window as any).USER_ID = userId;
    if (!getIsExistLoginType()) {
      navigate('/login');
      return;
    }
    if (pathname !== '/login' && !userId && !isWxLogin) {
      // if (isWxLogin) {
      //   if (loginType !== LOGIN_TYPE.wx) {
      //     // 如果是微信登录且不是首次进入而是回调的时候进入并且已经存在openId的情况下则调用
      //     getCaiUserInfo();
      //   }
      // } else {
      // 其他登录方式获取用户信息
      getCaiUserInfo();
      // }
      // isPswLogin && getPswUser();
    }
  }, [userId]);

  return (
    <Layout style={{ height: '100vh' }}>
      <Headers menus={menus} pathname={pathname} selectedKey={handMenuName}></Headers>
      <Layout className={styles.ant_layout_container}>
        {openKeys.length > 0 ? (
          <Sider width={200} theme="light">
            <SideMenu menus={sideMenu.children} openKeys={openKeys} pathname={pathname} userInfo={{ userRole, authList }}></SideMenu>
          </Sider>
        ) : null}
        <Content
          style={{
            padding: 24,
          }}
        >
          <Suspense fallback={<Spin tip="Loading" size="large" className={styles.content_spin}></Spin>}>
            <Routes>
              {ROUTER_CONFIG?.map((props, index) => (
                <Route
                  path={props.path}
                  key={index}
                  // element={props.element}
                  // 外部wx体系登录用户
                  element={
                    isWxLogin ? (
                      <WxLogin getCaiUserInfo={getCaiUserInfo} meta={props.meta || null} loginType={loginType}>
                        {props.element}
                      </WxLogin>
                    ) : isRtxLogin ? (
                      <AuthRoute meta={props.meta || null}>{props.element}</AuthRoute>
                    ) : (
                      <PswLogin meta={props.meta || null}>{props.element}</PswLogin>
                    )
                  }
                />
              ))}
            </Routes>
          </Suspense>
        </Content>
      </Layout>
      {/* <div className={styles.content_warpper}></div> */}
    </Layout>
  );
}

export default Layouts;
